import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const i18nModule = {
  state,
  mutations,
  actions,
  getters
};

export default i18nModule;